import {createContext} from "react";
import {AccordionContextType} from "./types";

export const AccordionContext = createContext<AccordionContextType>({
  onChange: () => {},
  crossBrand: false,
  minWidth: () => false,
  unstyled: false,
});
